module.exports = __webpack_public_path__ + "static/img/blue-logo.a46ad67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/blue-logo.png
// module id = Ryon
// module chunks = 0